import Client from './client';

export default class ShopifyMarketsWebhookRegistrations extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/shopify/markets/webhook/registrations`, options);
  }

}
